import React from "react";
import {
  SiGithub,
  SiX,
  SiDiscord,
  SiLinkedin,
  SiYoutube,
  SiTelegram,
} from "react-icons/si";

const iconClass =
  "w-5 h-5 sm:w-6 sm:h-6 text-white/90 group-hover:text-white/70 transition-transform group-hover:scale-105 md:group-hover:scale-110 md:my-4";

const FollowAs: React.FC = () => (
  <section className="mt-10 flex flex-col items-center text-center">
    <h5 className="text-sm sm:text-base font-semibold mb-1">Follow us</h5>
    <p className="text-xs text-white/50 mb-4">Social links coming soon...</p>

    <ul className="flex gap-5 justify-center">
      {/* ✅ Liens actifs */}
      <li className="group">
        <a
          href="https://t.me/nau_ucwaves"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Telegram"
        >
          <SiTelegram className={iconClass} />
        </a>
      </li>
      <li className="group">
        <a
          href="https://github.com/NextGenWaves/NAU-UcWaves"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="GitHub"
        >
          <SiGithub className={iconClass} />
        </a>
      </li>
      <li className="group">
        <a
          href="https://discord.com/invite/Z4SaDp9BFs"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Discord"
        >
          <SiDiscord className={iconClass} />
        </a>
      </li>
      <li className="group">
        <a
          href="https://x.com/ucwaves"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Discord"
        >
          <SiX className={iconClass} />
        </a>
      </li>

      {/* 🔒 Liens désactivés */}
      <li className="group opacity-60 pointer-events-none">
        <SiLinkedin className={iconClass} />
      </li>
      <li className="group opacity-60 pointer-events-none">
        <SiYoutube className={iconClass} />
      </li>
    </ul>
  </section>
);

export default FollowAs;
